(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyWorkDayDialogController', WeeklyWorkDayDialogController);

    WeeklyWorkDayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WeeklyWorkDay', 'WeeklyScheduleInfo'];

    function WeeklyWorkDayDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, WeeklyWorkDay, WeeklyScheduleInfo) {
        var vm = this;

        vm.weeklyWorkDay = entity;
        vm.clear = clear;
        vm.save = save;
        vm.weeklyscheduleinfos = WeeklyScheduleInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.weeklyWorkDay.id !== null) {
                WeeklyWorkDay.update(vm.weeklyWorkDay, onSaveSuccess, onSaveError);
            } else {
                WeeklyWorkDay.save(vm.weeklyWorkDay, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:weeklyWorkDayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
